import React from 'react';

const BlockInfos = ({ Logo, Telephone, StreetAddress, PostalCode, AddressLocality}) => {

  return (
    <div className="rf-px-6 rf-flex rf-flex-col large-vertical:rf-w-1/2 rf-items-center rf-text-center" style={{ height: 'calc(-3rem + 50vw)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        {Logo?.Paths && (
            <div
                style={{
                    maxWidth: '250px', 
                    maxHeight: '250px', 
                    borderRadius: '12px', 
                    overflow: 'hidden', 
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#fff'
                }}
            >
                <img
                    src={`https://studio.retorik.ai/mejstjegx80had7vep/media/${Logo.Paths[0]}`}
                    alt="Logo"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                    }}
                />
            </div>
        )}

        {StreetAddress?.Text && (
            <div className="rf-py-12">
                <div>{StreetAddress?.Text}</div>
                {(PostalCode?.Text || AddressLocality?.Text) && (
                    <div>
                        {PostalCode?.Text ?? ''}{PostalCode?.Text && AddressLocality?.Text ? ' ' : ''}{AddressLocality?.Text ?? ''}
                    </div>
                )}
            </div>
        )}

        {Telephone?.Text && (
            <div className="rf-px-5 rf-py-3 rf-mb-8 rf-flex rf-flex-row rf-items-center rf-font-bold">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 40" className="rf-h-6 rf-w-6 ltr:rf-mr-2 rtl:rf-ml-2">
                <g transform="translate(-183.86 -57.462) rotate(-21)">
                    <path d="M162.1,156.952a2.852,2.852,0,0,0,2.91-2.915V127.8a2.851,2.851,0,0,0-2.91-2.915H151.91A2.851,2.851,0,0,0,149,127.8v26.233a2.852,2.852,0,0,0,2.91,2.915ZM157,155.738a1.455,1.455,0,1,1,1.455-1.455A1.456,1.456,0,0,1,157,155.738Zm-2.183-29.072c0-.18.086-.322.194-.322h3.978c.106,0,.194.144.194.322v.086c0,.18-.087.322-.194.322h-3.978c-.106,0-.194-.144-.194-.322Zm-4.365,1.861h13.1V151.81h-13.1Zm0,0"></path>
                </g>
                </svg>
                <span  style={{ color: '#007bff', textDecoration: 'none' }}>
                {formatPhone(Telephone?.Text)}
                </span>
            </div>
        )}
        
        
        
    </div>
  );
};

const formatPhone = (num) => {
  if (!num) return '';
  const digits = num.replace(/\D/g, '');
  return digits
    .split('')
    .reverse()
    .join('')
    .match(/.{1,2}/g)
    ?.map(pair => pair.split('').reverse().join(''))
    .reverse()
    .join(' ') || '';
};


export default BlockInfos;

